import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      retry({ count: 1, delay: (error, _retryCount) => {
        // Retry only idempotent GET requests to avoid duplicating POST/PUT/DELETE side effects;
        // for non-GET propagate the original HTTP error instead of masking it.
        if (request.method !== 'GET') {
          return throwError(() => error);
        }
        return timer(0);
      }}),
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
